export const isDocumentationEnabled = false
export const isBlogEnabled = false
export const isSupportEnabled = false

export const allowModifyOfReviewLabels = false
